//Aqui
//Alterar para em projeto/producao e/ou Homolocao
// versao.js basutlaxios.js baseultapi.js api.js e ambiente.js
//Em Projeto
//const baseurlaxios = "https://localhost:44308/api"
//Homologacao
//const baseurlaxios = "http://pa.flag.com.br:81/api"
//Producao
const baseurlaxios = "https://back.heitools.com.br/api"
////const baseurlaxios = "http://back.heitools.com.br/api"
export default baseurlaxios